import { createSelector } from 'reselect';
import { linkGridFulfillmentFilterToPdpSelector } from 'selectors/testTarget/offers/linkGridFulfillmentFilterToPdp/linkGridFulfillmentFilterToPdpSelector';

const linkGridFulfillmentFilterToPdpExperienceSelector = createSelector(
    linkGridFulfillmentFilterToPdpSelector,
    linkGridFulfillmentFilterToPdp =>
        linkGridFulfillmentFilterToPdp?.experience === 'challenger'
);

export { linkGridFulfillmentFilterToPdpExperienceSelector };
